<template>
  <!-- All Invoice -->
  <div class="card invoices-tabs-card">
    <div class="invoices-main-tabs">
      <div class="row align-items-center">
        <div class="col-lg-12">
          <div class="invoices-tabs">
                 <div class="col-md-3 mb-3">
                
          <div class="form-custom">
            <input
              type="text"
              class="form-control form-control-sm"
              placeholder="Search anything..."
              :value="modelValue"
              @input="$emit('update:modelValue', $event.target.value)"
            />
        
          </div>
        </div>
            <ul>
              <li>
                <router-link
                  :class="
                    currentPath == 'transactions' ? 'active' : 'notactive'
                  "
                  to="/transactions"
                  >All</router-link
                >
              </li>
              <li>
                <router-link
                  :class="
                    currentPath == 'pending-transactions'
                      ? 'active'
                      : 'notactive'
                  "
                  to="/pending-transactions"
                  >Pending</router-link
                >
              </li>
              <li>
                <router-link
                  :class="
                    currentPath == 'approved-transactions'
                      ? 'active'
                      : 'notactive'
                  "
                  to="/approved-transactions"
                  >Approved</router-link
                >
              </li>
              <li>
                <router-link
                  :class="
                    currentPath == 'declined-transactions'
                      ? 'active'
                      : 'notactive'
                  "
                  to="/declined-transactions"
                  >Declined</router-link
                >
              </li>
              
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /All Invoice -->
</template>
<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
defineProps({
  modelValue: {
    type: String,
    default: "",
  },
});
const route = useRoute();
const currentPath = computed(() => {
  return route.name;
});
</script>
